import React, { Component } from 'react';
import { isLogged, onLogout, getUser } from '../_utils/localstorage';
import { isAdmin, isOpd, isBank, isVerificator, getTahunAnggaran } from '../_utils/localstorage';
import logo from '../logo.png'
import {Icon} from 'semantic-ui-react';

export default class Navbar extends Component {
    state = { open: false }

    onLogout(){
        if(onLogout()){
            window.location.href = '/';
        }
    }

    render() {
        
        return (
            <div>
                <div className="ui fixed inverted menu">
                <div style={{width: '98%'}} className="ui container">
                    <span className="header item">
                        <img style={{marginRight: '1.5em'}} className="logo" alt="Logo" src={logo} />
                        E-STS BAPPENDA Provinsi NTB <b style={{
                            backgroundColor: '#fff', color: "#6435c9",
                            marginLeft: '5px', padding: '3px'
                        }}>
                            {getTahunAnggaran() &&
                                `T.A.  ${getTahunAnggaran()}` 
                            }</b>
                    </span>
                    {isLogged() &&
                        <a href="/" className="item">Home</a>
                    }
                    {(isLogged() && isAdmin()) &&
                        <a className="item" href="/a/setting">Setting</a>
                    }

                    {(isLogged() && isBank()) &&
                        <div className="ui simple dropdown item">
                        Data Master <i className="dropdown icon"></i>
                            <div className="menu" style={{width:'200px'}}>
                                <a className="item" href="/c/sts">STS</a>

                                <div className="divider"></div>
                                <a className="item" href="/c/realisasi">Realisasi</a>

                                <div className="divider"></div>
                                <a className="item" href="/c/org">SKPD & OPD</a>
                            </div>
                        </div>
                    }

                    {(isLogged() && isAdmin()) &&
                        <div className="ui simple dropdown item">
                            Data Master <i className="dropdown icon"></i>
                            <div className="menu" style={{width:'200px'}}>
                                <a className="item" href="/a/bp">BP</a> 
                                
                                <div className="divider"></div> 
                                <a className="item" href="/a/sts">STS</a> 
                                <div className="divider"></div>     
                                <a className="item" href="/a/users">Users</a>
                                <div className="divider"></div>
                                <a className="item" href="/a/report">Report</a>
                                <div className="divider"></div>
                                <div className="item">
                                    <i className="dropdown icon"></i>
                                    SKPD & OPD
                                    <div className="menu">
                                        <a className="item" href="/a/org">SKPD & OPD</a> 
                                        
                                        <div className="divider"></div> 
                                        <a className="item" href="/a/re">Target & Realisasi</a> 
                                    </div>
                                </div>
                                
                            </div>
                        </div>                        
                    }

                    {(isLogged() && isVerificator()) &&
                        <div className="ui simple dropdown item">
                        Data Master <i className="dropdown icon"></i>
                            <div className="menu" style={{width:'200px'}}>
                                
                                <div className="divider"></div> 
                                <a className="item" href="/d/sts">STS</a> 
                                <div className="divider"></div>
                                <div className="item">
                                    <i className="dropdown icon"></i>
                                    SKPD & OPD
                                    <div className="menu">
                                        <a className="item" href="/d/org">SKPD & OPD</a> 
                                        
                                        <div className="divider"></div> 
                                        <a className="item" href="/d/re">Target & Realisasi</a> 
                                    </div>
                                </div>
                                <div className="divider"></div>
                                <a className="item" href="/d/report">Report</a>
                                {/* <div className="divider"></div>
                                <div className="item">
                                    <i className="dropdown icon"></i>
                                    SKPD & OPD
                                    <div className="menu">
                                        <a className="item" href="/d/org">SKPD & OPD</a> 
                                        
                                        <div className="divider"></div> 
                                        <a className="item" href="/d/re">Target & Realisasi</a> 
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    }

                    {(isLogged() && isOpd()) &&
                        <div className="ui simple dropdown item">
                        Data Master <i className="dropdown icon"></i>
                            <div className="menu" style={{width:'200px'}}>
                                
                                <a className="item" href="/b/kuasa">Kuasa Pengguna Anggaran</a>
                                        
                                <div className="divider"></div>                                        
                                <a className="item" href="/b/paraf">Bendahara Penerima</a>

                                <div className="divider"></div>                                        
                                <a className="item" href="/b/bank">Rekening Bank</a>
                                <div className="divider"></div>
                                <a className="item" href="/b/report">Report</a>
                                
                            </div>
                        </div>
                    }
                    {(isLogged() && isOpd()) &&
                        <div className="ui simple dropdown item">
                        BP <i className="dropdown icon"></i>
                            <div className="menu" style={{width:'200px'}}>
                                <a className="item" href="/b/bp">List BP</a>
                                <div className="divider"></div>
                                <a className="item" href="/b/newbp">Buat BP Baru</a>
                            </div>
                        </div>
                    }
                    {(isLogged() && isOpd()) &&
                        <div className="ui simple dropdown item">
                        STS <i className="dropdown icon"></i>
                            <div className="menu" style={{width:'200px'}}>
                                <a className="item" href="/b/sts">List STS</a>
                                <div className="divider"></div>
                                <a className="item" href="/b/newsts">Buat STS Baru</a>
                            </div>
                        </div>
                    }
                    

                    {isLogged() &&
                        <div className="right menu">
                            <a onClick={() => window.location.reload(true)} className="item"> <Icon name='refresh' className='left floated' /> Refresh</a>
                            
                            <div className="ui simple dropdown item">
                            {getUser()}
                            <i className="dropdown icon"></i>
                            <div className="menu" style={{width:'200px'}}>
                                {isAdmin() && <a className="item" href="/a/profile">Profile</a>}
                                {isOpd() && <a className="item" href="/b/profile">Profile</a>}
                                {isBank() && <a className="item" href="/c/profile">Profile</a>}
                                {isVerificator() && <a className="item" href="/d/profile">Profile</a>}
                                <div className="divider"></div>                              
                                <a className="item" onClick={this.onLogout.bind(this)}>Logout</a>
                            </div>
                            </div>
                        </div>
                    }
                </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Navmenu.js